var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"w"},[_c('img',{attrs:{"src":_vm.bannerPng,"alt":""},on:{"click":function($event){return _vm.$router.push('/qa')}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }